export const environment = {
  production: false,
  apiURl: 'https://dev-groupsales.service.3ddigitalvenue.com',
  authStorageKey: 'mmc_auth_data',
};
